import ModalContainer from '@elements/ModalContainer'
import Login from '@forms/Login'

const LoginModal = ({ isOpen }) => {
  return (
    <ModalContainer open={isOpen}>
      <Login />
    </ModalContainer>
  )
}

export default LoginModal
